<template>
  <div class="card card-with-shadow border-0 h-100 min-height-350">
    <div class="card-header bg-transparent p-primary d-flex justify-content-between align-items-center">
      <h5 class="card-title text-capitalize mb-0">{{ $t('user_poll_analytics') }}</h5>
    </div>
    <div class="card-body position-relative" :class="{ 'loading-opacity': preloader }">
      <app-overlay-loader v-if="loader"/>
      <app-chart
          v-else
          type="bar-chart"
          :height="380"
          :maximum-range="20"
          :labels="pollAnalyticsLabels"
          :data-sets="pollAnalyticsDataSet"
      />
    </div>
  </div>
</template>

<script>
import {axiosGet} from '../../../../../common/Helper/AxiosHelper';
import {APP_DASHBOARD} from '../../../../Config/ApiUrl';
import {mapState} from 'vuex';

export default {
  name: 'PollAnalytics',

  data() {
    return {
      preloader: false,
      pollAnalyticsLabels: [],
      pollAnalyticsDataSet: [
        {
          label: 'Responses Count',
          data: [],
          backgroundColor: '#019AFF',
          borderColor: '#019AFF',
          borderWidth: 1,
          barThickness: 25,
          barPercentage: 0.5
        }
      ]
    };
  },

  computed: {
    ...mapState({
      loader: state => state.loading
    })
  },

  created() {
    this.getPollAnalyticsData();
  },

  methods: {
    getPollAnalyticsData() {
      this.preloader = true;

      axiosGet(`${APP_DASHBOARD}/polls/analytics`)
          .then(({data}) => {
            const labels = [];
            const responses = [];

            data.forEach(poll => {
              labels.push(`Poll #${poll.poll_id}`);
              responses.push(poll.total_user);
            });

            this.pollAnalyticsLabels = labels;
            this.pollAnalyticsDataSet = [
              {
                label: '',
                data: responses,
                backgroundColor: '#019AFF',
                borderColor: '#019AFF',
                borderWidth: 1,
                barThickness: 25,
                barPercentage: 0.5
              }
            ];

            this.preloader = false;
          })
          .catch((err) => {
            console.error('Poll Analytics Error:', err.message);
            this.$toastr.e('Failed to load poll analytics data');
            this.preloader = false;
          });
    }
  }
};
</script>
